@import (reference) '../../../constants/spacing.module.less';
@import (reference) 'ui-components/components/text/text.module.less';
@import (reference) '../settings-page.module.less';

.sender-emails-page {
  overflow: auto;
  padding: @settings-page-content-padding;
  gap: @space-32;
}

.text-section {
  max-width: 1000px;
  gap: @space-16;
}

.help-article-link {
  .paragraph();
}
